import { render, staticRenderFns } from "./SalarySlips.vue?vue&type=template&id=5742a726"
import script from "./SalarySlips.vue?vue&type=script&lang=js"
export * from "./SalarySlips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports